import React from 'react';

const Sec2 = () => {
    return (
        <div className='text-center mb-10 md:mb-16'>
            <h2 className='text-3xl md:text-6xl font-bold my-10'>Life on LINE</h2>
            <p className='text-xl text-gray-600 font-semibold'>More than just a messenger app.</p>
            <p className='text-xl text-gray-600 font-semibold'>LINE is new level of communication, and the very infrastructure of your life.</p>
        </div>
    );
};

export default Sec2;